var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterlandPompebled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    fill: "none",
    viewBox: "0 0 17 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E82329",
    d: "M15.144 1.725a4.135 4.135 0 00-1.928-.977c-.534-.081-1.108-.081-1.641.082-.656.244-1.148.65-1.559 1.14-.574.732-.82 1.546-.902 2.442-.041.285-.246.488-.574.488a.574.574 0 01-.575-.488c-.04-.204-.04-.407-.082-.57-.205-.855-.574-1.628-1.271-2.28C5.832.83 4.889.545 3.782.748a3.79 3.79 0 00-2.38 1.506A4.304 4.304 0 00.5 4.9c0 1.506.451 2.93 1.272 4.274.45.692.984 1.343 1.6 1.873 1.353 1.18 2.912 1.913 4.716 2.238.329.041.616.041.944 0a9.072 9.072 0 003.568-1.384c.37-.244.739-.488 1.067-.814.656-.61 1.23-1.262 1.682-2.035.779-1.303 1.19-2.727 1.148-4.193.041-1.14-.369-2.238-1.353-3.134z"
  })));
}
export default SvgWaterlandPompebled;